import { render, staticRenderFns } from "./PersonalInfo.vue?vue&type=template&id=30f1c814&scoped=true"
import script from "./PersonalInfo.vue?vue&type=script&lang=js"
export * from "./PersonalInfo.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfo.vue?vue&type=style&index=0&id=30f1c814&prod&lang=css"
import style1 from "./PersonalInfo.vue?vue&type=style&index=1&id=30f1c814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f1c814",
  null
  
)

export default component.exports